import { getOrganizationClientTasksLink } from "@components/organizationView/clients-tasks/organizationTaskLink";
import { MONTH_END_CLOSE_VIEW_ID } from "@components/tasks/views/OrganizationTaskViews";
import { getOpenClientWorkLink, parseCloseId } from "@hooks/useOpenWorkRow";
import type { ClientsWorkOverviewWorkRow } from "./clientsWorkOverviewViewConfig";

type WorkLinkRow = Pick<ClientsWorkOverviewWorkRow, "workspaceId" | "closeId">;

/** Org Actions on Month-end close, filtered to the work's client and close. */
export const getWorkViewInActionsLink = (
    row: WorkLinkRow,
): string | undefined => {
    const closeId = parseCloseId(row.closeId);
    return closeId
        ? getOrganizationClientTasksLink({
              workspaceId: row.workspaceId,
              viewId: MONTH_END_CLOSE_VIEW_ID,
              closeId,
          })
        : undefined;
};

/** The work's workspace Tasks page on Month-end close, filtered to the close. */
export const getWorkOpenClientLink = (row: WorkLinkRow): string | undefined => {
    const closeId = parseCloseId(row.closeId);
    return closeId
        ? getOpenClientWorkLink({ workspaceId: row.workspaceId, closeId })
        : undefined;
};
